export default __webpack_public_path__ + "static/media/background.e4f3110a.png";